import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260126_add_reportable_unit_designations",
  description: "Add reportableUnitDesignations table to docs that don't have it",
  apply(json: any): any {
    if (!json.reportableUnitDesignations) {
      json.reportableUnitDesignations = {};
    }
    return json;
  },
};

export default migration;
